import { Component ,NgZone } from '@angular/core';
import { NavController, NavParams , ViewController } from 'ionic-angular';


/**
 * Generated class for the GoogleMapsAutocompletePage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-google-maps-autocomplete',
  templateUrl: 'google-maps-autocomplete.html',
})
export class GoogleMapsAutocompletePage {

  autocompleteItems;
  autocompleteItems2;
  autocomplete;
  autocomplete2;
  public gmob : any;
  service;
  public nameString1 : any;
  public nameString2 : any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, private zone: NgZone) {

    let tmpGoogle = this.navParams.get('gmob');
    this.service = new tmpGoogle.maps.places.AutocompleteService();
    this.autocompleteItems = [];
    this.autocompleteItems2 = [];
    this.autocomplete = {
      query: ''
    };

    this.autocomplete2 = {
      query: ''
    };
    
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad GoogleMapsAutocompletePage');
  }

  dismiss() {
    let x = {};
     x['res1'] = '';
     x['res2'] = '';
     x['showError'] = false;
    this.viewCtrl.dismiss(x);
  }
 
  chooseItem(item: any) 
  {
    //console.log(item);
    this.autocomplete.query = item;
    this.autocompleteItems = [];
    //this.viewCtrl.dismiss(item);
  }

  chooseItem2(item: any) 
  {
      this.autocomplete2.query = item;
    this.autocompleteItems2 = [];
    //this.viewCtrl.dismiss(item);
  }

  distanceMeasure()
  {
     let x = {};
     x['res1'] = this.autocomplete.query;
     x['res2'] = this.autocomplete2.query;
     x['showError'] = true;
    //console.log(x);
    this.viewCtrl.dismiss(x);
  }
  
  updateSearch() {
    if (this.autocomplete.query == '') {
      this.autocompleteItems = [];
      return;
    }
    let me = this;
    this.service.getPlacePredictions({ input: this.autocomplete.query, componentRestrictions: {country: 'IN'} }, function (predictions, status) {
      me.autocompleteItems = []; 
      me.zone.run(function () {
        //console.log(predictions);
        if(predictions !== null)
        {
            if(predictions.length > 0)
            {
                predictions.forEach(function (prediction) {
                  me.autocompleteItems.push(prediction.description);
                });
            }
        }
        
      });
    });
  }

    updateSearch2() {
    if (this.autocomplete2.query == '') {
      this.autocompleteItems2 = [];
      return;
    }
    let me = this;
    this.service.getPlacePredictions({ input: this.autocomplete2.query, componentRestrictions: {country: 'IN'} }, function (predictions, status) {
      me.autocompleteItems2 = []; 
      me.zone.run(function () {
        //console.log(predictions);
        if(predictions !== null)
        {
            if(predictions.length > 0)
            {
              predictions.forEach(function (prediction) {
              me.autocompleteItems2.push(prediction.description);
            });  
            }
        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/google-maps-autocomplete/google-maps-autocomplete.ts